import { object, string } from 'yup'
import { FormSchema } from '../Wizard/Form/Types'
import { topic } from './shared/topic'
import { brandVoiceId, tone } from './shared/voiceTones'
import { avoid } from './shared/avoid'
import { language } from './shared/language'
import { Outline } from 'almanac-ui/icons/blaze/32'
import { safify } from './utils/safify'
import { sourceMaterialIds } from './shared/sourceMaterials'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { includeImages } from './shared/includeImages'
import { MultiStepSchema, StepSchema } from 'components/Wizards/schemas/Types'
import { SelectImages } from 'components/Wizards/schemas/shared/selectImages'
import { brandKitId } from './shared/brandKitId'
import { TextChannels } from '../../../constants'

const meta = {
  type: GenerationType.Outline,
  steps: ['Context', 'Generate Outline'],
  title: TextChannels[GenerationType.Outline].name,
  submitLabel: 'Generate Outline',
  icon: Outline,
  previewUrl:
    'https://res.cloudinary.com/almanac/image/upload/v1710183781/Home%20Card%20Previews/ecpwxergbuwox5oxuhjo.png',
}

const fields = {
  topic: topic.meta({ label: 'What is the topic of your outline?', generationType: meta.type }),
  structure: string()
    .oneOf([
      'Traditional',
      'Problem-Solution',
      'How-to',
      'Storytelling',
      'Interview',
      'Video/Podcast Script',
      'Discussion',
    ])
    .default('Traditional')
    .meta({ label: 'What structure should the outline follow?', autoFill: true })
    .transform(safify),
  brand_voice_id: brandVoiceId,
  brand_kit_id: brandKitId,
  source_material_ids: sourceMaterialIds,
  include_images: includeImages,
  tone,
  language,
  avoid: avoid.meta({ collapsible: true }),
}

export const OutlineSchema = object(fields).meta(meta) as FormSchema<GenerationType | ChannelType>

export const OutlineMultiStepSchema: MultiStepSchema<GenerationType.Outline> = {
  steps: [
    OutlineSchema.omit(['include_images']).meta({
      title: 'Purpose & Goals',
      submitLabel: 'Select Images',
    }) as StepSchema,
    SelectImages.meta({ submitLabel: meta.submitLabel, type: meta.type }) as StepSchema,
  ],
  meta: {
    ...meta,
    type: GenerationType.Outline,
    channel: GenerationType.Outline,
  },
}
